/* eslint-disable */
const apiConfig = {
  restServiceDomain: VARS.API_DOMAIN,
};

export default apiConfig;



// WEBPACK FOOTER //
// ./app/utils/apiConfig.js